import React, { useState, useEffect } from "react"

import { connect } from "react-redux"
import { Row, Col } from "reactstrap"
import API from "../../api/axios"
// Pages Components
import Miniwidget from "./Miniwidget"
import MonthlyEarnings from "./montly-earnings"
import EmailSent from "./email-sent"
import MonthlyEarnings2 from "./montly-earnings2"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions"

const Dashboard = props => {
  document.title = "Dashboard | Lexa - Responsive Bootstrap 5 Admin Dashboard"
  const [counts, setCounts] = useState({
    patients: 0,
    doctors: 0,
    services: 0,
    appointments: 0,
  })

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem("authToken")

        const [patientsRes, doctorsRes, servicesRes,appointmentRes] = await Promise.all([
          API.get("/patients/count", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          API.get("/users/count", {
            headers: { Authorization: `Bearer ${token}` },
          }),
          API.get("/services/count", {
            headers: { Authorization: `Bearer ${token}` },
          }),

           API.get("/appointments/count", {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ])

        setCounts({
          patients: patientsRes.data.count,
          doctors: doctorsRes.data.count,
          services: servicesRes.data.count,
          appointments:appointmentRes.data.count,

        })
      } catch (err) {
        console.error("Error fetching dashboard counts", err)
      }
    }

    fetchCounts()

    const interval = setInterval(fetchCounts, 60000)

    // Cleanup interval when component unmounts
    return () => clearInterval(interval)
  }, [])

  const breadcrumbItems = [
    // { title: "Lexa", link: "#" },
    { title: "Dashboard", link: "#" },
  ]

  useEffect(() => {
    props.setBreadcrumbItems("Dashboard", breadcrumbItems)
  })

  const reports = [
    {
      title: "Patients",
      iconClass: "account",
      total: counts.patients,
      
      badgecolor: "info",
    },
    {
      title: "Doctors",
      iconClass: "stethoscope",
      total: counts.doctors,
      
      badgecolor: "warning",
    },
    {
      title: "Services",
      iconClass: "file-document",
      total: counts.services,
      
      badgecolor: "success",
    },
    {
      title: "Appointments Today",
      iconClass: "calendar",
      total: counts.appointments,
      
      badgecolor: "danger",
    },
  ]

  return (
    <React.Fragment>
      {/*mimi widgets */}
      <Miniwidget reports={reports} />

      <Row>
        <Col xl="3">
          {/* Monthly Earnings */}
          <MonthlyEarnings />
        </Col>

        <Col xl="6">
          {/* Email sent */}
          <EmailSent />
        </Col>

        <Col xl="3">
          <MonthlyEarnings2 />
        </Col>
      </Row>
      <Row>
    
      
       
      </Row>

      
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard)
